import { Text } from '@mantine/core'
import { modals } from '@mantine/modals'
import { Trans } from 'react-i18next'
import i18n from '@/i18n'
import { SLIDER_ENGINE_TEMPLATE_IDS, isSliderV3 } from '../../utils/sliderValidation'

export function templateLabel(template) {
  return `${template.name} · v${template.version}`
}

/**
 * "Change the template?" — shared by Campaign Setting and Step 1. Says what happens to the ad:
 * restored from its snapshot, carried over (Split Slider / Story / Reel share the content
 * engine) or restarted from the new template's defaults.
 */
export function confirmTemplateChange({ editor, reference, label, onConfirm }) {
  const target = (editor.templates || []).find((entry) => (entry.releaseKey || entry.id) === reference)
  const name = label || (target ? templateLabel(target) : reference)
  const carries = isSliderV3(editor.configuration) && SLIDER_ENGINE_TEMPLATE_IDS.includes(target?.id)
  const restores = Boolean(target && editor.hasTemplateSnapshot?.(target.family, target.releaseKey || target.id))
  modals.openConfirmModal({
    title: i18n.t('editorV2.shell.templateChange.title'),
    centered: true,
    radius: 'lg',
    children: restores ? (
      <Text size="sm">
        <Trans i18nKey="editorV2.shell.templateChange.restores" values={{ name }} components={{ b: <b /> }} />
      </Text>
    ) : carries ? (
      <Text size="sm">
        <Trans
          i18nKey={target?.id === 'reel-v1' ? 'editorV2.shell.templateChange.carriesReel' : 'editorV2.shell.templateChange.carries'}
          values={{ name }}
          components={{ b: <b /> }}
        />
      </Text>
    ) : (
      <Text size="sm">
        <Trans i18nKey="editorV2.shell.templateChange.resets" values={{ name }} components={{ b: <b /> }} />
      </Text>
    ),
    labels: { confirm: i18n.t('editorV2.shell.templateChange.confirm'), cancel: i18n.t('editorV2.shell.templateChange.cancel') },
    confirmProps: { color: carries || restores ? 'smartico-pink' : 'red' },
    onConfirm,
  })
}
